/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum AvailableModels {
  ALIAS_ANTHROPIC_CLAUDE_3_5_SONNET = 'alias/anthropic/claude-3.5-sonnet',
  ALIAS_ANTHROPIC_CLAUDE_3_7_SONNET = 'alias/anthropic/claude-3.7-sonnet',
  ALIAS_OPENAI_GPT_4O = 'alias/openai/gpt-4o',
  GPT_4O = 'gpt-4o',
  CLAUDE_3_5_SONNET_LATEST = 'claude-3-5-sonnet-latest',
  CLAUDE_3_7_SONNET_LATEST = 'claude-3-7-sonnet-latest',
}
